import React from "react";
import { useTranslation } from "react-i18next";

import { Block, Button, Typography } from "@stepapp/ui";

type Props = {
  editable?: boolean;
  errors?: false | string;
  label: string;
  value: string;
  handleEditPress: () => void;
  testID?: string;
};

const HomeInfoItem = ({ editable, errors, label, value, handleEditPress, testID }: Props) => {
  const { t } = useTranslation();

  return (
    <Block alignCenter justifySpace row paddingHorizontal={2} paddingVertical={2}>
      <Block>
        <Block marginBottom={1}>
          <Typography type={errors ? "error" : "secondary"}>{label}</Typography>
        </Block>
        <Typography>{value}</Typography>
      </Block>
      <Button
        disabled={!editable}
        label={value ? t("common.edit") : t("common.add")}
        onPress={handleEditPress}
        testID={testID}
        type="link"
      />
    </Block>
  );
};

export default React.memo(HomeInfoItem);
